module.exports = __webpack_public_path__ + "img/twitter_b.263f343f.svg";